import React from 'react';
import { useParams } from 'react-router-dom';
import "../Destination/DestinationDetail.css"
import { Link } from 'react-router-dom';
import FlightDeal from '../FlightDeals/FlightDeals';
import DestinationDeals from './DestinationDeal';

const destinationData = {
  australia: [
    { city: "Brisbane", firstClass: 3432, businessClass: 1964, premiumEconomy: 1240, economy: 712, image: "/barisbane.JPG", link: "/" },
    { city: "Cairns", firstClass: 3584, businessClass: 2864, premiumEconomy: 1340, economy: 668, image: "/Cairns.jpg", link: "/" },
    { city: "Adelaide", firstClass: 3328, businessClass: 2124, premiumEconomy: 1248, economy: 680, image: "/Adelaide.jpg", link: "/" },
  ],
  canada: [
    { city: "Vancouver", firstClass: 3728, businessClass: 2520, premiumEconomy: 1560, economy: 784, image: "/ca2.jpg", link: "/" },
    { city: "Toronto", firstClass: 3600, businessClass: 2400, premiumEconomy: 1440, economy: 760, image: "/ca1.jpg", link: "/" },
    { city: "Montreal", firstClass: 3760, businessClass: 2560, premiumEconomy: 1600, economy: 816, image: "/ca3.jpg", link: "/" }
  ],
  caribbean: [
    { city: "Jamaica", firstClass: 3760, businessClass: 2560, premiumEconomy: 1280, economy: 720, image: "/car2.jpg", link: "/" },
    { city: "Bahamas", firstClass: 3920, businessClass: 2640, premiumEconomy: 1440, economy: 736, image: "/car3.jpg", link: "/" },
    { city: "Barbados", firstClass: 3840, businessClass: 2480, premiumEconomy: 1360, economy: 680, image: "/car1.jpg", link: "/" },
  ],
  "far-east": [
    { city: "Bangkok", firstClass: 3840, businessClass: 2800, premiumEconomy: 1600, economy: 760, image: "/far2.jpg", link: "/" },
    { city: "Tokyo", firstClass: 4240, businessClass: 3200, premiumEconomy: 1680, economy: 880, image: "/far1.jpg", link: "/" },
    { city: "Singapore", firstClass: 4160, businessClass: 2960, premiumEconomy: 1760, economy: 800, image: "/far3.jpg", link: "/" },
  ],
  "indian-ocean": [
    { city: "Seychelles", firstClass: 4640, businessClass: 3520, premiumEconomy: 2000, economy: 920, image: "/io3.jpg", link: "/" },
    { city: "Maldives", firstClass: 4800, businessClass: 3600, premiumEconomy: 1920, economy: 960, image: "/io1.webp", link: "/" },
    { city: "Mauritius", firstClass: 4400, businessClass: 3360, premiumEconomy: 1840, economy: 880, image: "/io2.avif", link: "/" },
  ],
  "middle-east": [
    { city: "Abu Dhabi", firstClass: 4480, businessClass: 2960, premiumEconomy: 1760, economy: 800, image: "/me2.webp", link: "/" },
    { city: "Doha", firstClass: 4400, businessClass: 2880, premiumEconomy: 1600, economy: 720, image: "/me3.webp", link: "/" },
    { city: "Dubai", firstClass: 4560, businessClass: 3040, premiumEconomy: 1680, economy: 760, image: "/me1.jpg", link: "/" },
  ],
  "new-zealand": [
    { city: "Christchurch", firstClass: 3840, businessClass: 2720, premiumEconomy: 1760, economy: 880, image: "/nz3.jpg", link: "/" },
    { city: "Auckland", firstClass: 3680, businessClass: 2560, premiumEconomy: 1600, economy: 800, image: "/nz1.jpg", link: "/" },
    { city: "Wellington", firstClass: 3760, businessClass: 2640, premiumEconomy: 1680, economy: 840, image: "/nz2.webp", link: "/" },
  ],
  "south-africa": [
    { city: "Johannesburg", firstClass: 4160, businessClass: 3040, premiumEconomy: 1760, economy: 800, image: "/sa2.jpg", link: "/" },
    { city: "Durban", firstClass: 4240, businessClass: 3120, premiumEconomy: 1840, economy: 840, image: "/sa3.jpeg", link: "/" },
    { city: "Cape Town", firstClass: 4080, businessClass: 2960, premiumEconomy: 1680, economy: 760, image: "/sa1.webp", link: "/" },
  ],
  "south-america": [
    { city: "Lima", firstClass: 4400, businessClass: 3360, premiumEconomy: 1800, economy: 840, image: "/sm3.jpg", link: "/" },
    { city: "Rio de Janeiro", firstClass: 4480, businessClass: 3280, premiumEconomy: 1840, economy: 920, image: "/sm1.jpg", link: "/" },
    { city: "Buenos Aires", firstClass: 4320, businessClass: 3200, premiumEconomy: 1760, economy: 880, image: "/sm2.webp", link: "/" },
  ],
  usa: [
    { city: "Chicago", firstClass: 3760, businessClass: 2640, premiumEconomy: 1600, economy: 800, image: "/usa3.jpg", link: "/" },
    { city: "New York", firstClass: 3840, businessClass: 2720, premiumEconomy: 1680, economy: 880, image: "/usa1.jpg", link: "/" },
    { city: "Los Angeles", firstClass: 3920, businessClass: 2800, premiumEconomy: 1760, economy: 920, image: "/usa2.webp", link: "/" },
  ]
};


  const destinations = [
    { 
      id: "australia", 
      city: "Australia", 
      business: "£2235", 
      first: "£3256", 
      details: "Australia is known for its beautiful beaches, unique wildlife, and diverse landscapes. From the Great Barrier Reef to the Outback, Australia offers endless adventures. Whether you're looking for a relaxing beach vacation or an exciting wildlife safari, Australia has something for everyone.",
      heading: "Explore the Land Down Under",
      text: "Australia offers an exciting range of activities from surfing on world-famous beaches to exploring the Great Barrier Reef. You can also experience the diverse culture in its vibrant cities like Sydney and Melbourne. Australia is perfect for both adventure seekers and those looking to relax.",
      subtext: "A perfect destination for adventure seekers and culture lovers.",
      cityImage: "/aus1.jpg",
      experienceImage: "/businessclass3.jpg",
      about: "Australia is known for its unique wildlife, stunning landscapes, and diverse culture. It's an iconic destination that blends natural beauty with modern city life.",
    },
    { 
      id: "canada", 
      city: "Canada", 
      business: "£1680", 
      first: "£2800", 
      details: "Canada offers stunning landscapes and vibrant cities, making it an ideal destination for both nature lovers and urban explorers. The Rocky Mountains, Niagara Falls, and cosmopolitan cities like Toronto and Vancouver make Canada a must-visit.",
      heading: "Discover Canada’s Natural Beauty",
      text: "From the stunning Rocky Mountains to the cosmopolitan vibe of cities like Toronto, Canada is a country full of wonders. Whether you're hiking through Banff National Park or exploring multicultural cities, Canada promises unforgettable experiences. It offers an incredible mix of natural beauty and modern life.",
      subtext: "A country for nature lovers and city explorers alike.",
      cityImage: "/canada.jpg",
      experienceImage: "/canadae.jpg",
      about: "A vast country known for its natural beauty, friendly people, and multicultural cities. Whether you're exploring wilderness or indulging in city life, Canada never fails to impress.",
    },
    { 
      id: "caribbean", 
      city: "Caribbean", 
      business: "£1560", 
      first: "£2640", 
      details: "Caribbean destinations feature crystal-clear waters, white sandy beaches, and a laid-back vibe. Whether you're lounging on the beach or exploring vibrant local culture, the Caribbean offers an escape to paradise.",
      heading: "Relax in the Caribbean",
      text: "The Caribbean is a collection of islands known for their stunning beaches, crystal-clear waters, and warm tropical weather. Whether you want to explore local cultures, enjoy watersports, or simply unwind by the beach, the Caribbean is the perfect getaway.",
      subtext: "Ideal for beach lovers and sunseekers.",
      cityImage: "/carribean.jpg",
      experienceImage: "/carribeane.jpg",
      about: "A group of islands with a tropical climate, offering a perfect blend of relaxation and adventure. The Caribbean is famous for its stunning beaches, vibrant culture, and friendly locals.",
    },
    { 
      id: "far-east", 
      city: "Far East", 
      business: "£1760", 
      first: "£2880", 
      details: "Explore the ancient cultures and cuisines of the Far East, with vibrant cities like Tokyo and Bangkok. Whether you're interested in history, architecture, or food, the Far East offers a wealth of experiences.",
      heading: "Discover the Mystical Far East",
      text: "The Far East offers a blend of ancient traditions and modern innovations. From the temples of Japan to the bustling markets of Bangkok, this region is full of surprises. Explore the rich cultural heritage, indulge in delicious cuisines, and discover serene landscapes.",
      subtext: "A destination that mixes tradition and modernity.",
      cityImage: "/fareast.jpg",
      experienceImage: "/fareaste.jpg",
      about: "The Far East is home to diverse cultures, stunning temples, and bustling cities. A region where the old meets the new, offering travelers a fascinating experience of both history and modernity.",
    },
    { 
      id: "indian-ocean", 
      city: "Indian Ocean", 
      business: "£1840", 
      first: "£3040", 
      details: "The Indian Ocean islands offer a mix of luxury resorts, pristine beaches, and diverse marine life. From the Maldives to Seychelles, the Indian Ocean is a dream destination for those seeking luxury and relaxation.",
      heading: "Relax on the Indian Ocean Islands",
      text: "The Indian Ocean is home to some of the world's most luxurious resorts and stunning beaches. Whether you're looking to indulge in world-class spa treatments or dive into vibrant coral reefs, these islands are perfect for a serene and luxurious vacation.",
      subtext: "Ideal for those looking for a tranquil escape.",
      cityImage: "/indianocean.jpg",
      experienceImage: "/indianoceane.jpg",
      about: "Known for its luxurious resorts, clear waters, and stunning coral reefs, the Indian Ocean offers a truly exotic experience. Perfect for a relaxing and rejuvenating getaway.",
    },
    { 
      id: "middle-east", 
      city: "Middle East", 
      business: "£1680", 
      first: "£2880", 
      details: "Experience the rich history, culture, and modern marvels of the Middle East. From the opulent cities of Dubai to the ancient wonders of Egypt, this region is a fascinating blend of tradition and modernity.",
      heading: "Explore the Wonders of the Middle East",
      text: "The Middle East is a region of contrasts, where ancient civilizations meet modern technology. From the deserts of Saudi Arabia to the grand architecture of Dubai, the Middle East offers a mix of history, luxury, and adventure.",
      subtext: "A land of history, luxury, and innovation.",
      cityImage: "/middleeast.jpg",
      experienceImage: "/middleeaste.jpg",
      about: "The Middle East is home to ancient wonders, grand cities, and rich cultural heritage. It’s a region that blends tradition with cutting-edge innovation and modern luxury.",
    },
    { 
      id: "new-zealand", 
      city: "New Zealand", 
      business: "£2320", 
      first: "£3360", 
      details: "New Zealand is a paradise for nature lovers, offering a range of landscapes from mountains to beaches. Known for its adventure sports, it’s the perfect place for thrill-seekers and nature enthusiasts.",
      heading: "Discover the Beauty of New Zealand",
      text: "New Zealand is a land of breathtaking beauty, from its snow-capped mountains to its lush green valleys. It’s a haven for outdoor enthusiasts, offering activities like hiking, bungee jumping, and skiing. Whether you're seeking adventure or tranquility, New Zealand offers the perfect escape.",
      subtext: "A paradise for nature lovers and adventure seekers.",
      cityImage: "/newzealand.jpg",
      experienceImage: "/newzealande.jpg",
      about: "Known for its stunning natural landscapes, New Zealand is an adventure lover's dream. It’s also home to a friendly population and a thriving cultural scene.",
    },
    { 
      id: "south-africa", 
      city: "South Africa", 
      business: "£2100", 
      first: "£3120", 
      details: "South Africa offers incredible safaris, stunning beaches, and vibrant cities. It’s a country of contrasts, offering both natural wonders and urban excitement.",
      heading: "Safari and City Adventures in South Africa",
      text: "South Africa is a country that offers both thrilling safaris and vibrant cities. From the stunning beaches of Cape Town to the wildlife of Kruger National Park, it’s the perfect destination for nature lovers and urban explorers alike. South Africa promises an unforgettable experience for every traveler.",
      subtext: "Perfect for safari lovers and city explorers.",
      cityImage: "/southafrica.jpg",
      experienceImage: "/southafricae.jpg",
      about: "A country that blends natural beauty with urban excitement, South Africa is a must-visit destination for those looking for adventure and relaxation.",
    },
    { 
      id: "south-america", 
      city: "South America", 
      business: "£1920", 
      first: "£2960", 
      details: "South America is a continent of rich cultures and stunning landscapes, from the Amazon rainforest to the Andes mountains. Experience diverse cultures, ancient ruins, and vibrant cities.",
      heading: "Experience the Wonders of South America",
      text: "South America is a continent full of diverse cultures, breathtaking landscapes, and ancient wonders. From the mystique of Machu Picchu to the vibrant cities of Brazil, South America offers a wealth of experiences for every traveler. Whether you’re exploring jungles, mountains, or bustling markets, there’s something for everyone.",
      subtext: "A land of culture, adventure, and history.",
      cityImage: "/southamerica.jpg",
      experienceImage: "/southamericae.jpg",
      about: "Known for its rich cultural heritage and stunning natural beauty, South America is a continent that will captivate your heart with its vibrant atmosphere and diverse experiences.",
    },
    { 
      id: "usa", 
      city: "USA", 
      business: "£1600", 
      first: "£2720", 
      details: "From bustling cities to national parks, the USA offers a wide variety of experiences. Whether you're exploring New York City or hiking through the Grand Canyon, the USA has something for everyone.",
      heading: "Discover the Diversity of the USA",
      text: "The USA is a diverse country, offering everything from world-famous cities like New York and Los Angeles to stunning natural wonders like the Grand Canyon and Yellowstone. Whether you're looking for cultural experiences, outdoor adventures, or world-class entertainment, the USA has it all.",
      subtext: "A diverse country full of adventure and excitement.",
      cityImage: "/usa.jpg",
      experienceImage: "/usae.jpg",
      about: "A vast country with diverse landscapes, cultures, and experiences. From iconic cities to breathtaking national parks, the USA has something for every traveler.",
    }
  ];
  

  const DestinationDetail = () => {
    const { id } = useParams();
    const flights = destinationData[id] || [];
    const destination = destinations.find(dest => dest.id === id.toLowerCase());
  
    if (!destination) {
      return <h2>Destination not found</h2>;
    }


    
const calladmin = () => {
  window.location.href = "tel:02039449931";
};
  return (
    <>

 <DestinationDeals/>
 <div className="text-center p-8">
      <h2 className="text-2xl font-bold mb-4 he">{destination.heading}</h2>
      <p className="het">{destination.text}</p>
    {/*- <p className="het">{destination.subtext}</p>-*/} 
    </div>



    <div className="image-sectionn">
      <h2 className="section-headingn">{destination.city}</h2>
      <img
        src={destination.cityImage}
        alt="Destination"
        className="section-imagen"
      />
    </div>









    <div className="business-flight-container">
    <div className="left-section">
        <h2>Cheap {destination.city} Business Class Flights </h2>
        <p>
          {destination.about}
        </p>
        <p>
         {destination.details}
        </p>
        <h3>The Benefits of Journey Experts Business Class</h3>
        <img src="/businessclass2.jpg" alt="Business Class Seat" />
        <h4>Sit, Recline, and Lie in Comfort</h4>
        <p>
        More often than not, business class seats are the peak of luxury and well on par with First Class. After a high-powered meeting, or a week in the sun, nothing beats the extra space and a seat that recline at the push of a button.
        </p>


        <h3>Fine Dining at 30,000 ft</h3>
        <p>Unlike on an economy class flight, business class passengers have access to complimentary champagne, world-class foods, and recipes from award-winning chefs.</p>
        
        <h3>In-flight Privacy</h3>
        <p>As one market closes, another opens, and if deadlines are looming, the privacy of business class allows a quiet, comfortable, and tranquil space to get things done. Equally, it’s simply a quiet spot to kick back, relax, and take the weight off your shoulders.</p>
        
        <h3>Pre-flight entertainment</h3>
        <p>With our cheap business class flights, customers will often also have the benefit of enjoying exclusive lounges before take-off. They’ll have an array of wines, spirits, and nicely chilled champagne, and in some airports you can even take advantage of a spa.</p>
        
        <h3>Priority boarding & Chauffeur Service</h3>
        <p>Boarding can be one of the most frustrating aspects of travel; when journey experts business class, you board before premium and economy passengers.</p>
        
        <h3>An upgraded experience</h3>
        <img src={destination.experienceImage} alt="Business Class Seat" />
        <p>Etihad's inflight chef on their business class flights. When you Journey Experts business class, you notice the difference from when you step into the terminal. We can arrange for access to a business class lounge, so you aren’t stuck trying to find a seat at the busy airport and can sit back and relax. When you enjoy business class travel, you often get perks such as priority boarding, so you aren’t fighting the crowds.</p>
        
        <p>You can even start the luxury experience before you get to the airport by booking a chauffeur, so there’s no need to worry about that stressful drive to catch your flight. Journey Experts Business can book your cheap business class flights, as well as those little extras that make your experience so much more enjoyable.</p>
        
        <h3>Cheaper flights</h3>
        <p>Because Journey Experts are experts in business class travel, we can give you a cheaper rate than booking directly through the airline. Our friendly, knowledgeable team can book business flights all over the world, whether you’re travelling for work or leisure. ATOL protected and with excellent reviews, we can ensure that you get the best rate for your trip.</p>
        
        <h3>A relaxing flight</h3>
        <p>From bigger seats to upgraded dining, there are endless reasons to Journey Experts business class. You can enjoy a quiet, secluded cabin with a more attentive level of service. Our cheap business flights allow you to fly with some of the world’s best airlines at a reasonable price, and take advantage of on-board facilities from reclining seats to complimentary champagne, and even private pods.</p>
        
        <p>To get the best price on your business class flight, simply call Journey Experts today, or fill in the above contact form so we can get back to you.</p>
      </div>

      <div className='right-section'>
      <div className="price-container">
      {flights.map((flight, index) => (
        <div key={index} className="price-card">
          <h3>Flights To {flight.city}</h3>
          <ul>
            <li>
              <span>✈ First Class from <strong>£{flight.firstClass}</strong></span>
            </li>
            <li>
              <span>✈ Business Class From <strong>£{flight.businessClass}</strong></span>
            </li>
            <li>
              <span>✈ Premium Economy From <strong>£{flight.premiumEconomy}</strong></span>
            </li>
            <li>
              <span>✈ Economy From <strong>£{flight.economy}</strong></span>
            </li>
          </ul>
          <img src={flight.image} alt={flight.city} className="flight-image" />
          <Link to={flight.link}>
      <button className='get-price-btn'>Get Price</button>
    </Link>
                           <button className='get-price-btn' onClick={calladmin}>Call Now</button>
        </div>
      ))}
    </div>
      </div>
     
    </div>



   
    </>
  );
};

export default DestinationDetail;
